/**
 * Canonical width tokens for side panels and drawers.
 *
 * OVERLAY_* – for modal drawers that slide over the page (SideDrawer / FormSideDrawer).
 * INLINE_*  – for panels embedded in the page layout (e.g. diagram detail panels).
 */

/** Narrow overlay drawers (chat, quick actions) */
export const OVERLAY_SM = 400;

/** Medium overlay drawers (form drawers) */
export const OVERLAY_MD = 600;

/** Large overlay drawers (rich content) */
export const OVERLAY_LG = 800;

/** Narrow inline sidebars (editor navigation) */
export const INLINE_SM = 280;

/** Medium inline panels (diagram detail panels) */
export const INLINE_MD = 430;
